import { SearchParams } from "../reatom/state/search/types";

export const sanitizeParams = (params: SearchParams): Record<string, any> =>
  Object.fromEntries(
    Object.entries(params)
      .filter(([, value]) => value != null && value !== false)
      .map(([key, value]) => [
        key,
        key === "sort_by" && value === "default"
          ? ""
          : value === true
          ? 1
          : value,
      ])
  );
